module.exports = __webpack_public_path__ + "static/media/What Vault Users Want…Enhancing Vault Thin Client.d951231b.png";